// client/src/pages/Certificados.jsx
import { useEffect, useState } from "react";
import Toast from "../components/Toast";
import {
  getCertificateTemplate,
  updateCertificateTemplate,
  emitCertificate,
  getNextCertificateNumber,
} from "../services/certificates";
import { listUsers } from "../services/users"; // Corregido
import { listCourses } from "../services/courses"; // Corregido
import { Eye } from "lucide-react";

function formatearFechaLarga(isoDate) {
  if (!isoDate) return "";
  const meses = [
    "enero","febrero","marzo","abril","mayo","junio",
    "julio","agosto","septiembre","octubre","noviembre","diciembre",
  ];

  // 👇 CORREGIDO: Manejar zona horaria correctamente
  let d;
  if (typeof isoDate === 'string' && isoDate.match(/^\d{4}-\d{2}-\d{2}$/)) {
    const [year, month, day] = isoDate.split('-').map(Number);
    d = new Date(year, month - 1, day); // Crear fecha en zona horaria local
  } else {
    d = new Date(isoDate);
  }

  const dia = String(d.getDate()).padStart(2, "0");
  const mes = meses[d.getMonth()];
  const anio = d.getFullYear();
  return `Lima, ${dia} de ${mes} de ${anio}`;
}

export default function Certificados() {
  const [tpl, setTpl] = useState(null);
  const [users, setUsers] = useState([]);
  const [courses, setCourses] = useState([]);

  const [form, setForm] = useState({
    userId: "",
    courseId: "",
    emitDate: new Date().toISOString().substring(0, 10),
    gerenteNombre: "",
    backgroundFile: null,
    firmaFile: null,
  });

  const [preview, setPreview] = useState({ backgroundUrl: "", firmaUrl: "" });
  const [toast, setToast] = useState(null);
  const showToast = (type, message, ms = 2200) => {
    setToast({ type, message });
    setTimeout(() => setToast(null), ms);
  };

  const loadAll = async () => {
    try {
      const [tplRes, usersRes, coursesRes] = await Promise.all([
        getCertificateTemplate(),
        listUsers(), // Corregido
        listCourses(), // Corregido
      ]);

      setTpl(tplRes);
      setForm((f) => ({
        ...f,
        gerenteNombre: tplRes.gerenteNombre || ""
      }));
      setPreview({
        backgroundUrl: tplRes.backgroundUrl || "",
        firmaUrl: tplRes.firmaUrl || "",
      });

      setUsers(Array.isArray(usersRes) ? usersRes : []); // Corregido
      setCourses(Array.isArray(coursesRes) ? coursesRes : []); // Corregido
    } catch (e) {
      console.error(e?.response?.data || e.message);
      showToast("error", "No se pudieron cargar datos");
    }
  };

  useEffect(() => {
    loadAll();
  }, []);

  // ⛔ ELIMINADO: Ya no se autocompleta el número desde el frontend
  // El backend generará el número automáticamente al emitir

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  };

  const onFile = (name) => (e) => {
    const file = e.target.files?.[0] || null;
    setForm((s) => ({ ...s, [name]: file }));
    if (name === "backgroundFile" && file) {
      setPreview((p) => ({ ...p, backgroundUrl: URL.createObjectURL(file) }));
    }
    if (name === "firmaFile" && file) {
      setPreview((p) => ({ ...p, firmaUrl: URL.createObjectURL(file) }));
    }
  };

  const saveTemplate = async () => {
    try {
      await updateCertificateTemplate({
        gerenteNombre: form.gerenteNombre,
        backgroundFile: form.backgroundFile || undefined,
        firmaFile: form.firmaFile || undefined,
      });
      await loadAll();
      showToast("success", "Plantilla actualizada correctamente");
    } catch (e) {
      console.error(e?.response?.data || e.message);
      showToast("error", "No se pudo actualizar la plantilla");
    }
  };

  const emitir = async () => {
    if (!form.userId || !form.courseId) {
      showToast("warn", "Selecciona alumno y curso");
      return;
    }
    try {
      await emitCertificate({
        userId: form.userId,
        courseId: form.courseId,
        // ⛔ NO enviar número - el backend lo genera automáticamente
        emitDate: form.emitDate,
      });
      showToast("success", "Certificado emitido correctamente");
    } catch (e) {
      console.error(e?.response?.data || e.message);
      const errorMsg = e?.response?.data?.mensaje || e?.response?.data?.detalle || "No se pudo emitir el certificado";
      showToast("error", errorMsg);
    }
  };

  // Datos dinámicos para la previa
  const alumno = users.find((u) => u._id === form.userId);
  const curso = courses.find((c) => c._id === form.courseId);

  const alumnoNombre = (() => {
    const n = alumno?.nombre || "";
    const ap = alumno?.apellido || "";
    return n && ap ? `${n} ${ap}` : n || "Nombre del alumno";
  })();

  const cursoTitulo = curso?.titulo || "Nombre del curso";
  const gerente = form.gerenteNombre || "Gerente General";
  const fechaLarga = formatearFechaLarga(form.emitDate);
  const anioActual = form.emitDate ? new Date(form.emitDate).getFullYear() : new Date().getFullYear();

  const horas = (() => {
    const t = (cursoTitulo || "").toLowerCase();
    if (t.includes("actualización")) return 5;
    if (t.includes("oficial de protección radiológica")) return 50;
    return 20;
  })();

  const openPreviewTab = () => {
    const bg = preview.backgroundUrl || tpl?.backgroundUrl || "";
    const firma = preview.firmaUrl || tpl?.firmaUrl || "";
    const bigNumber = "XXX"; // Placeholder ya que el número se asigna al emitir

    const html = `
<!doctype html>
<html>
<head>
<meta charset="utf-8"/>
<title>Vista previa certificado</title>
<meta name="viewport" content="width=device-width,initial-scale=1"/>
<style>
  :root { --pad: 14%; }
  body{margin:0;background:#f6f7f8;font-family:ui-sans-serif,system-ui,-apple-system,"Segoe UI",Roboto}
  .wrap{width:90vw;max-width:1100px;margin:24px auto;background:#fff;border-radius:12px;box-shadow:0 10px 30px rgba(0,0,0,.08);padding:16px;}
  .canvas{position:relative;width:100%;aspect-ratio:1.414/1;background:#f9fafb;border-radius:8px;overflow:hidden}
  .bg{position:absolute;inset:0;width:100%;height:100%;object-fit:cover}
  .layer{position:absolute;inset:0;padding:var(--pad);font-size:14px;color:#111}
  .top{width:100%;text-align:center;margin-top:7%}
  .num{font-weight:800;font-size:28px;margin-bottom:6px}
  .bio{font-weight:700;font-size:16px}
  .title{margin-top:6px;font-size:16px}
  .alumno{margin-top:2px;font-weight:800;font-size:30px}
  .texto{margin-top:8px;font-size:15px;line-height:1.35}
  .texto b{font-weight:700}
  .fecha{position:absolute;left:7%;bottom:9%;font-size:12px}
  .firmaBox{position:absolute;right:12%;bottom:11%;display:flex;flex-direction:column;align-items:center}
  .firmaImg{height:70px;object-fit:contain;margin-bottom:-8px}
  .line{border-top:1px solid #222;width:220px;margin-top:2px}
  .gerente{margin-top:6px;font-size:12px}
  .cargo{font-size:11px;color:#6b7280}
</style>
</head>
<body>
  <div class="wrap">
    <div class="canvas">
      ${bg ? `<img class="bg" src="${bg}"/>` : ``}
      <div class="layer">
        <div class="top">
          <div class="num">CERTIFICADO N°${bigNumber}</div>
          <div class="bio">BIO-${anioActual}</div>
          <div class="title">Certificado de aprobación para:</div>
          <div class="alumno">${alumnoNombre}</div>
          <div class="texto">
            Por haber completado satisfactoriamente el curso:
            <b> ${cursoTitulo}</b> con una duración de
            <b> ${horas}</b> horas académicas.
          </div>
        </div>

        <div class="fecha">${fechaLarga}</div>

        <div class="firmaBox">
          ${firma ? `<img class="firmaImg" src="${firma}"/>` : ``}
          <div class="line"></div>
          <div class="gerente">${gerente}</div>
          <div class="cargo">Gerente General</div>
        </div>
      </div>
    </div>
  </div>
</body>
</html>`;
    const w = window.open("", "_blank");
    if (w) {
      w.document.open();
      w.document.write(html);
      w.document.close();
    }
  };

  return (
    <div className="w-full">
      {toast && (
        <Toast
          type={toast.type}
          message={toast.message}
          onClose={() => setToast(null)}
        />
      )}

      <h1 className="text-xl sm:text-2xl font-bold text-gray-700 mb-4 sm:mb-6 text-center sm:text-left">Certificados</h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
        {/* Formulario */}
        <div className="bg-white rounded-xl shadow p-4 sm:p-6">
          <h2 className="text-base sm:text-lg font-semibold mb-4 text-center sm:text-left">Datos</h2>

          <div className="space-y-3">
            <div>
              <label className="block text-xs sm:text-sm mb-1 font-medium">Alumno</label>
              <select
                name="userId"
                value={form.userId}
                onChange={onChange}
                className="w-full border rounded px-3 py-2 text-sm"
              >
                <option value="">Seleccione…</option>
                {users.map((u) => (
                  <option key={u._id} value={u._id}>
                    {u.nombre}
                    {u.apellido ? ` ${u.apellido}` : ""} — {u.correo}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-xs sm:text-sm mb-1 font-medium">Curso</label>
              <select
                name="courseId"
                value={form.courseId}
                onChange={onChange}
                className="w-full border rounded px-3 py-2 text-sm"
              >
                <option value="">Seleccione…</option>
                {courses.map((c) => (
                  <option key={c._id} value={c._id}>
                    {c.titulo}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-xs sm:text-sm mb-1 font-medium">Fecha de emisión</label>
              <input
                type="date"
                name="emitDate"
                value={form.emitDate}
                onChange={onChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
              <p className="text-xs text-gray-500 mt-1">
                💡 El número del certificado se asigna automáticamente de forma incremental
              </p>
            </div>

            <div>
              <label className="block text-xs sm:text-sm mb-1 font-medium">Representante (Gerente)</label>
              <input
                name="gerenteNombre"
                value={form.gerenteNombre}
                onChange={onChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="block text-xs sm:text-sm mb-1 font-medium">Cambiar fondo (PNG/JPG)</label>
                <input
                  type="file"
                  accept="image/png,image/jpeg"
                  onChange={onFile("backgroundFile")}
                  className="w-full text-xs sm:text-sm"
                />
              </div>
              <div>
                <label className="block text-xs sm:text-sm mb-1 font-medium">Cambiar firma (PNG/JPG)</label>
                <input
                  type="file"
                  accept="image/png,image/jpeg"
                  onChange={onFile("firmaFile")}
                  className="w-full text-xs sm:text-sm"
                />
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 pt-2">
              <button
                onClick={saveTemplate}
                className="w-full sm:w-auto px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 text-sm font-medium"
              >
                Guardar plantilla
              </button>
              <button
                onClick={emitir}
                className="w-full sm:w-auto px-4 py-2 rounded bg-green-600 text-white hover:bg-green-700 text-sm font-medium"
              >
                Emitir certificado
              </button>
            </div>
          </div>
        </div>

        {/* Vista previa */}
        <div className="bg-white rounded-xl shadow p-4 sm:p-6">
          <div className="flex items-center justify-between mb-3">
            <h2 className="text-base sm:text-lg font-semibold">Vista previa</h2>
            <button
              onClick={openPreviewTab}
              className="inline-flex items-center gap-2 px-3 py-1.5 rounded border hover:bg-gray-50 text-sm"
              title="Ver en otra pestaña"
            >
              <Eye size={16} />
              <span className="hidden sm:inline">Ver</span>
            </button>
          </div>

          <div className="relative w-full aspect-[1.414/1] border rounded overflow-hidden bg-gray-50">
            {/* fondo */}
            {preview.backgroundUrl ? (
              <img
                src={preview.backgroundUrl}
                alt="fondo"
                className="absolute inset-0 w-full h-full object-cover"
              />
            ) : tpl?.backgroundUrl ? (
              <img
                src={tpl.backgroundUrl}
                alt="fondo"
                className="absolute inset-0 w-full h-full object-cover"
              />
            ) : (
              <div className="absolute inset-0 flex items-center justify-center text-gray-400">
                (Sube un fondo PNG/JPG)
              </div>
            )}

            {/* overlays */}
            <div className="absolute inset-0 p-[10%] sm:p-[14%]">
              {/* bloque superior - 👇 TAMAÑOS DE FUENTE AUMENTADOS */}
              <div className="w-full text-center mt-[5%] sm:mt-[7%]">
                <div className="text-lg sm:text-2xl font-extrabold leading-none mb-1">
                  CERTIFICADO N° XXX
                </div>
                <div className="font-bold text-xs sm:text-sm">BIO-{anioActual}</div>
                <div className="mt-1 text-xs sm:text-[15px]">Certificado de aprobación para:</div>
                <div className="text-xl sm:text-3xl font-extrabold leading-tight mt-1">
                  {alumnoNombre}
                </div>
                <div className="mt-2 text-xs sm:text-[15px] leading-snug px-2 sm:px-0">
                  Por haber completado satisfactoriamente el curso:
                  <span className="font-semibold"> {cursoTitulo}</span> con una
                  duración de
                  <span className="font-semibold"> {horas}</span> horas académicas.
                </div>
              </div>

              {/* fecha abajo izquierda */}
              <div className="absolute left-[5%] sm:left-[7%] bottom-[9%] text-[10px] sm:text-[12px]">
                {fechaLarga}
              </div>

              {/* firma + gerente abajo derecha - 👇 POSICIÓN SUBIDA */}
              <div className="absolute right-[15%] sm:right-[28%] bottom-[12%] sm:bottom-[14%] flex flex-col items-center">
                {(preview.firmaUrl || tpl?.firmaUrl) && (
                  <img
                    src={preview.firmaUrl || tpl?.firmaUrl}
                    alt="firma"
                    className="h-10 sm:h-14 object-contain -mb-2"
                  />
                )}
                <div className="border-t w-32 sm:w-56" />
                <div className="text-[10px] sm:text-[12px] mt-1 text-center">{gerente}</div>
                <div className="text-[9px] sm:text-[11px] text-gray-500">Gerente General</div>
              </div>
            </div>
          </div>

          <p className="text-xs text-gray-500 mt-2 text-center sm:text-left">
            * La posición de los textos es fija por ahora.
          </p>
        </div>
      </div>
    </div>
  );
}
